var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Field, Form, FormSpy } from 'react-final-form';
import { Button, FFMobileInput, FFTextInput, GBTypography } from '@leapfinance/geebee-component-library';
import { InfoOutlined } from '@mui/icons-material';
import Close from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Box, Checkbox, Divider, IconButton } from '@mui/material';
import '@leapfinance/geebee-component-library/src/styles/tailwind.css';
var max50CharsAndRequired = function (value) {
    return value ? ((value === null || value === void 0 ? void 0 : value.length) > 50 ? 'Max 50 characters' : false) : 'Required';
};
var indianMobileValidation = function (value) {
    if ((value === null || value === void 0 ? void 0 : value.countryCode) === '+91' && (value === null || value === void 0 ? void 0 : value.number) && !/^[3-9][0-9]{9}$/.test(value === null || value === void 0 ? void 0 : value.number)) {
        return 'Enter valid mobile number';
    }
    return false;
};
var requiredMobileNumber = function (value) {
    if (!(value === null || value === void 0 ? void 0 : value.number))
        return 'Required';
    return indianMobileValidation(value);
};
var validEmailValidation = function (value) {
    return !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value) && 'Enter valid email';
};
export var validRequiredUserName = function (value) {
    if (!value)
        return 'Required';
    if (/[^A-Za-z0-9]/.test(value)) {
        return 'No special Characters allowed';
    }
    else if (value.length > 50) {
        return 'Max 50 characters';
    }
    else if ((value === null || value === void 0 ? void 0 : value.length) < 4) {
        return 'Min 4 characters required';
    }
    return false;
};
export function AddSubAgentForm(_a) {
    var _this = this;
    var _b;
    var isLoading = _a.isLoading, onClose = _a.onClose, onCreate = _a.onCreate, domain = _a.domain, initialValues = _a.initialValues, checkForDuplicateUserName = _a.checkForDuplicateUserName;
    var _c = __read(useState(false), 2), passwordVisible = _c[0], setPasswordVisible = _c[1];
    return (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-justify-center lfc-h-full" },
        React.createElement(Form, { onSubmit: function (values) {
                onCreate === null || onCreate === void 0 ? void 0 : onCreate(values);
            }, initialValues: __assign(__assign({}, initialValues), { subAgentId: initialValues === null || initialValues === void 0 ? void 0 : initialValues.subAgentId, sendEmails: (_b = initialValues === null || initialValues === void 0 ? void 0 : initialValues.sendEmails) !== null && _b !== void 0 ? _b : true }), render: function (_a) {
                var _b;
                var handleSubmit = _a.handleSubmit, form = _a.form;
                return (React.createElement("div", { className: "lfc-bg-white lfc-border lfc-rounded-lg lfc-w-[408px] lfc-max-h-[90%] lfc-overflow-y-auto lfc-custom-scrollbar" },
                    React.createElement("div", { className: "lfc-p-4 lfc-flex lfc-justify-between lfc-items-center lfc-sticky lfc-top-0 lfc-bg-white lfc-z-10 lfc-shadow-md" },
                        React.createElement(GBTypography, { variant: "sh1" }, "Add Sub Agent"),
                        React.createElement(IconButton, { onClick: function () { return onClose === null || onClose === void 0 ? void 0 : onClose(); } },
                            React.createElement(Close, null))),
                    React.createElement(Divider, null),
                    React.createElement("div", { className: "lfc-p-4 lfc-flex lfc-flex-col lfc-gap-4" },
                        React.createElement(FFTextInput, { fieldProps: {
                                name: 'companyName',
                                validate: max50CharsAndRequired
                            }, componentProps: {
                                label: 'Company Name',
                                placeholder: 'Enter company name',
                                required: true
                            } }),
                        React.createElement(FFMobileInput, { fieldProps: {
                                name: 'mobileNumber',
                                validate: indianMobileValidation
                            }, componentProps: {
                                label: 'Phone Number',
                                placeholder: 'Enter phone number'
                            } }),
                        React.createElement(FFTextInput, { fieldProps: {
                                name: 'email',
                                validate: function (value) { return value && validEmailValidation(value); }
                            }, componentProps: {
                                label: 'Email',
                                placeholder: 'Enter email id',
                                type: 'email'
                            } }),
                        React.createElement(FFTextInput, { fieldProps: { name: 'officeAddress', validate: function (value) { return value && max50CharsAndRequired(value); } }, componentProps: {
                                label: 'Office Address',
                                placeholder: 'Enter Address'
                            } }),
                        React.createElement(FFTextInput, { fieldProps: { name: 'gstin' }, componentProps: {
                                label: 'GSTIN',
                                placeholder: 'Enter GSTIN'
                            } }),
                        React.createElement(FFTextInput, { fieldProps: {
                                name: 'additionalRemark',
                                validate: function (value) { return value && value.length > 2000 && 'Max 2000 characters'; }
                            }, componentProps: {
                                label: 'Additional Remark',
                                placeholder: 'Enter additional remarks you want to share',
                                multiline: true,
                                rows: 5
                            } }),
                        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-2" },
                            React.createElement(GBTypography, { variant: "sh2Semibold" }, "User details"),
                            React.createElement("div", { className: "lfc-bg-gbTokens-primary-100 lfc-flex lfc-flex-col lfc-gap-3 lfc-p-2 lfc-border lfc-rounded-md" },
                                React.createElement(GBTypography, { variant: "caption1", className: "lfc-flex lfc-items-start lfc-text-gbTokens-grey-A800" },
                                    React.createElement("span", null,
                                        React.createElement(InfoOutlined, { className: "lfc-text-xs lfc-mr-1" })),
                                    "These details will be used for creating credentials for the sub agent user on Unisetu"),
                                React.createElement(FFTextInput, { fieldProps: { name: 'user.firstName', validate: max50CharsAndRequired }, componentProps: {
                                        label: 'User First Name',
                                        placeholder: 'Enter first name',
                                        required: true,
                                        InputProps: {
                                            className: 'lfc-bg-white'
                                        }
                                    } }),
                                React.createElement(FFTextInput, { fieldProps: { name: 'user.lastName', validate: max50CharsAndRequired }, componentProps: {
                                        label: 'User Last name',
                                        placeholder: 'Enter last name',
                                        required: true,
                                        InputProps: {
                                            className: 'lfc-bg-white'
                                        }
                                    } }),
                                React.createElement(Box, { sx: {
                                        '.MuiOutlinedInput-root': {
                                            backgroundColor: 'white'
                                        }
                                    } },
                                    React.createElement(FFMobileInput, { fieldProps: {
                                            name: 'user.mobileNumber',
                                            validate: requiredMobileNumber
                                        }, componentProps: {
                                            label: 'User Phone Number',
                                            placeholder: 'Enter phone number',
                                            required: true
                                        } })),
                                React.createElement(FFTextInput, { fieldProps: { name: 'user.email', validate: validEmailValidation }, componentProps: {
                                        label: 'User Email Address',
                                        placeholder: 'Enter email id',
                                        required: true,
                                        InputProps: {
                                            className: 'lfc-bg-white'
                                        }
                                    } }),
                                React.createElement(FFTextInput, { fieldProps: {
                                        name: 'user.userName',
                                        validate: function (value) { return __awaiter(_this, void 0, void 0, function () {
                                            var _a, _b;
                                            return __generator(this, function (_c) {
                                                switch (_c.label) {
                                                    case 0:
                                                        if (!(initialValues === null || initialValues === void 0 ? void 0 : initialValues.subAgentId)) return [3 /*break*/, 1];
                                                        _a = false;
                                                        return [3 /*break*/, 4];
                                                    case 1:
                                                        _b = validRequiredUserName(value);
                                                        if (_b) return [3 /*break*/, 3];
                                                        return [4 /*yield*/, (checkForDuplicateUserName === null || checkForDuplicateUserName === void 0 ? void 0 : checkForDuplicateUserName(value))];
                                                    case 2:
                                                        _b = (_c.sent());
                                                        _c.label = 3;
                                                    case 3:
                                                        _a = _b;
                                                        _c.label = 4;
                                                    case 4: return [2 /*return*/, _a];
                                                }
                                            });
                                        }); }
                                    }, componentProps: {
                                        label: 'Username',
                                        placeholder: 'Enter Username',
                                        required: true,
                                        disabled: !!(initialValues === null || initialValues === void 0 ? void 0 : initialValues.subAgentId),
                                        InputProps: {
                                            className: 'lfc-bg-white',
                                            endAdornment: domain && React.createElement(GBTypography, { variant: "body3" },
                                                "@",
                                                domain)
                                        }
                                    } }),
                                !(initialValues === null || initialValues === void 0 ? void 0 : initialValues.subAgentId) && (React.createElement(FFTextInput, { fieldProps: {
                                        name: 'user.password',
                                        validate: function (value) {
                                            return !value ? 'Required' : value.length < 6 ? 'Min 6 characters required' : false;
                                        }
                                    }, componentProps: {
                                        label: 'Password',
                                        placeholder: 'Enter password',
                                        required: true,
                                        InputProps: {
                                            className: 'lfc-bg-white',
                                            endAdornment: (React.createElement(IconButton, { onClick: function () {
                                                    setPasswordVisible(!passwordVisible);
                                                } }, !passwordVisible ? React.createElement(VisibilityIcon, null) : React.createElement(VisibilityOffIcon, null)))
                                        },
                                        type: passwordVisible ? 'text' : 'password'
                                    } })),
                                React.createElement("div", { className: "lfc-flex lfc-items-start lfc-gap-2" },
                                    React.createElement("div", null,
                                        React.createElement(Field, { name: "sendEmails", render: function (_a) {
                                                var input = _a.input;
                                                return (React.createElement(Checkbox, { value: input === null || input === void 0 ? void 0 : input.value, onChange: function (_, checked) {
                                                        var _a;
                                                        (_a = input === null || input === void 0 ? void 0 : input.onChange) === null || _a === void 0 ? void 0 : _a.call(input, checked);
                                                    }, size: "small", disableRipple: true, className: "lfc-p-0", checked: input === null || input === void 0 ? void 0 : input.value }));
                                            } })),
                                    React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-gbTokens-grey-A800" }, "Allow Geebee to send status update emails to these associates. No other communications will be sent directly to sub-agents"))))),
                    React.createElement(FormSpy, { subscription: { submitFailed: true }, onChange: function () {
                            var el = document.querySelector('.Mui-error');
                            console.log(el);
                            if (el) {
                                el.scrollIntoView({ behavior: 'smooth' });
                            }
                        } }),
                    React.createElement("div", { className: "lfc-p-4 lfc-sticky lfc-bottom-0 lfc-bg-white lfc-shadow-t-md" },
                        React.createElement(Button, { fullWidth: true, disabled: (_b = form.getState()) === null || _b === void 0 ? void 0 : _b.hasValidationErrors, onClick: handleSubmit, loading: isLoading },
                            (initialValues === null || initialValues === void 0 ? void 0 : initialValues.subAgentId) ? 'Update' : 'Create',
                            " Sub Agent"))));
            } })));
}
export default AddSubAgentForm;
//# sourceMappingURL=AddSubAgentForm.js.map